var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{ref:"webcomponent",tag:"component",attrs:{"value":_vm.valueComp,"fetch-url":_vm.fetchUrl},on:{"webcomponent:update":$ev => _vm.update($ev)}})
}
var staticRenderFns = []

export { render, staticRenderFns }